import { render, staticRenderFns } from "./ExistingDocumentEditor.vue?vue&type=template&id=45ac25bd&"
import script from "./ExistingDocumentEditor.vue?vue&type=script&lang=ts&"
export * from "./ExistingDocumentEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ExistingDocumentEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports